import React from "react";
import {
  BacktestingJobResults,
  BacktestingRunType,
  BotData,
  FormattedChartDataPoint,
  TradeData,
} from "@shared/types";

export const BacktestDetailsContext = React.createContext<
  | {
      botData?: BotData;
      backtestingRun?: BacktestingRunType;
      loading?: boolean;
      backtestingJobResults: BacktestingJobResults;
      liveBarChartData: FormattedChartDataPoint[];
      liveBacktestingData?: BacktestingRunType;
      inProgress?: boolean;
      openTradesData?: TradeData[];
      closedTradesData?: TradeData[];
    }
  | undefined
>(undefined);
